import React, { useState } from 'react';
import { FieldState } from 'components/common/form-utils/form-state';
import { Icon } from 'components/common/Icon';
import Rating from 'components/common/Rating';
import { TextField } from 'components/common/TextField';
import generateLocator from 'utils/generate-locator';
import { convertFileToBase64 } from 'utils/image';
import { checkCircleIcon } from 'assets/icons';

const FieldEditor = ({ fieldName, field }: { fieldName: string, field: FieldState }) => {
  const [imageUpdated, setImageUpdated] = useState(false);
  const commonProps = {
    'aria-label': `Edit value of field ${fieldName}`,
    'id': generateLocator(fieldName, 'edit'),
  };
  if (fieldName === 'image') {
    return <span>
      <input
        {...commonProps}
        type='file'
        className='w-full'
        onChange={async (event) => {
          if (event.target.files) {
            field.setValue(
              await convertFileToBase64(event.target.files[0] as File).then(img => img as string),
            );
            setImageUpdated(true);
          }
        }} />
      {imageUpdated && <span className='absolute p-1 pr-1'>
        <Icon label='Image uploaded successfully' src={checkCircleIcon} />
      </span>}
    </span>;
  } else if (fieldName === 'stars') {
    return <span >
      <Rating
        {...commonProps}
        className='align-middle'
        size={13}
        ratingValue={field.value ? Number.parseInt(field.value) : 0}
        onClick={(index) => field.setValue(index.toString())} />
    </span>;
  } else if (fieldName === 'visible') {
    return <input
      {...commonProps}
      type='checkbox'
      checked={field.value === 'true'}
      onChange={() => field.setBoolean(!field.getBoolean())} />;
  }
  
  return <TextField
    id={commonProps.id}
    value={field.value ? field.value.toString() : ''}
    onChange={e => field.setValue(e.target.value)}
    fieldProps={{ ...commonProps }}/>;
};

export default FieldEditor;
